(function () {
  try {
  /** @type {Record<string, unknown>} */
  var config = { labels: {}, freeShippingThreshold: 50000, clubMultiplier: 5 };
  /** @type {{ rules?: Record<string, string[]>; pairings?: Record<string, string[]>; vendorFallback?: Record<string, string[]>; products?: object[] }} */
  var crossSellData = { products: [] };
  /** @type {HTMLElement | null} */
  var drawerEl = null;
  /** @type {HTMLElement | null} */
  var errorEl = null;
  /** @type {HTMLElement | null} */
  var lastFocusEl = null;
  var isOpen = false;
  /** @type {ReturnType<typeof setTimeout> | null} */
  var flashTimer = null;
  /** @type {ReturnType<typeof setTimeout> | null} */
  var errorTimer = null;
  /** @type {object | null} */
  var productByHandle = {};
  /** @type {Record<number, {compareAt:number}>} */
  var priceInfoCache = {};

  function loadConfig() {
    var node = document.getElementById('vibee-cart-drawer-config');
    if (!node) return;
    try {
      config = JSON.parse(node.textContent || '{}');
    } catch (e) {
      console.error('vibee-cart-drawer: config parse error', e);
    }
  }

  function isAllowedCrossSellProduct(product) {
    if (!product || !product.handle) return false;
    var vendor = String(product.vendor || '');
    if (vendor === 'Routine+' || vendor === 'Routine') return false;
    if (String(product.handle).toLowerCase().indexOf('routine') >= 0) return false;
    return true;
  }

  function loadCrossSell() {
    var node = document.getElementById('vibee-cart-cross-sell-data');
    if (!node) return;
    try {
      crossSellData = JSON.parse(node.textContent || '{}');
    } catch (e) {
      console.error('vibee-cart-drawer: cross-sell parse error', e);
    }
    productByHandle = {};
    (crossSellData.products || []).forEach(function (p) {
      if (p && p.handle && isAllowedCrossSellProduct(p)) productByHandle[p.handle] = p;
    });

    // rating map: config.ratingByHandle + cross-sell products
    window.__vibeeRatingMap = window.__vibeeRatingMap || {};
    var cfgR = (config && config.ratingByHandle) || {};
    Object.keys(cfgR).forEach(function (h) { window.__vibeeRatingMap[h] = cfgR[h]; });
    (crossSellData.products || []).forEach(function (p) {
      if (p && p.handle && p.rating != null && p.reviewCount >= 10) {
        window.__vibeeRatingMap[p.handle] = { rating: p.rating, count: p.reviewCount };
      }
    });
  }

  function ratingMiniHtml(handle) {
    var r = (window.__vibeeRatingMap || {})[handle];
    if (!r || r.rating == null || Number(r.count) < 10) return '';
    var score = (Math.round(Number(r.rating) * 10) / 10).toFixed(1);
    var count = formatTrInteger(r.count);
    return (
      '<span class="vibee-rating-mini vibee-rating-mini--xs">' +
      '<span class="vibee-rating-mini__star" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5l2.9 5.9 6.5 1-4.7 4.6 1.1 6.5-5.8-3.1-5.8 3.1 1.1-6.5-4.7-4.6 6.5-1L12 2.5z"/></svg>' +
      '</span><span class="vibee-rating-mini__score">' + score + '</span>' +
      '<span class="vibee-rating-mini__count">(' + count + ')</span></span>'
    );
  }

  function label(key, fallback) {
    var labels = config.labels || {};
    return labels[key] || fallback || '';
  }

  function formatMoney(cents) {
    if (typeof window.vibeeMoneyDisplay === 'function') {
      return window.vibeeMoneyDisplay(cents, config.moneyFormat);
    }
    if (typeof window.vibeeMoney === 'function') {
      return window.vibeeMoney(cents, config.moneyFormat);
    }
    if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, config.moneyFormat || window.Shopify.money_format);
    }
    return (Number(cents || 0) / 100).toFixed(2) + ' TL';
  }

  function interpolate(template, vars) {
    var out = template || '';
    Object.keys(vars).forEach(function (key) {
      out = out.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), String(vars[key]));
    });
    return out;
  }

  function formatTrInteger(n) {
    return String(Math.max(0, Math.round(Number(n) || 0))).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getDrawer() {
    if (drawerEl) return drawerEl;
    drawerEl = document.querySelector('[data-vibee-cart-drawer]');
    return drawerEl;
  }

  function fetchCart() {
    return fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_fetch_failed');
      return response.json();
    });
  }

  function ensurePriceInfo(cart) {
    var need = {};
    (cart.items || []).forEach(function (it) {
      if (it.handle && it.variant_id && !(it.variant_id in priceInfoCache)) need[it.handle] = true;
    });
    var handles = Object.keys(need);
    if (!handles.length) return Promise.resolve();
    return Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (p && p.variants) {
              p.variants.forEach(function (v) {
                priceInfoCache[v.id] = { compareAt: Number(v.compare_at_price) || 0 };
              });
            }
          })
          .catch(function () {});
      }),
    );
  }

  function updateHeaderCartCount(cart) {
    var count = Number(cart && cart.item_count) || 0;
    document.querySelectorAll('.vibee-icon-link--cart').forEach(function (cartLink) {
      var icon = cartLink.querySelector('.vibee-icon-link__icon');
      if (!icon) return;
      var badge = icon.querySelector('.vibee-icon-link__badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('sup');
          badge.className = 'vibee-icon-link__badge';
          icon.appendChild(badge);
        }
        badge.textContent = String(count);
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function dispatchCartEvents(cart) {
    var detail = { cart: cart, openMiniCart: false };
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true, detail: detail }),
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }),
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:build', { bubbles: true, detail: { cart: cart } }),
    );
  }

  function calculateClubPoints(totalCents) {
    var multiplier = Number(config.clubMultiplier) || 5;
    var priceTl = Math.floor(Number(totalCents || 0) / 100);
    var rawPoints = priceTl * multiplier;
    var remainder = rawPoints % 50;
    var points = rawPoints - remainder;
    if (remainder >= 25) points += 50;
    var valueTl = Math.floor(points / 100);
    return { points: points, valueTl: valueTl };
  }

  function itemProp(item, key) {
    if (!item || !item.properties) return '';
    return item.properties[key] || item.properties['_' + key] || '';
  }

  function computeDiscounts(cart) {
    var setDiscount = 0;
    var subscriptionDiscount = 0;
    (cart.items || []).forEach(function (item) {
      var original = Number(item.original_line_price) || 0;
      var final = Number(item.final_line_price) || Number(item.line_price) || 0;
      var diff = Math.max(0, original - final);
      if (itemProp(item, 'bundle_id')) setDiscount += diff;
      else if (item.selling_plan_allocation || itemProp(item, 'purchase_mode') === 'subscription') {
        subscriptionDiscount += diff;
      }
    });
    return { setDiscount: setDiscount, subscriptionDiscount: subscriptionDiscount };
  }

  function renderShippingBar(cart) {
    var el = getDrawer();
    if (!el) return;
    var threshold = Number(config.freeShippingThreshold) || 50000;
    var total = Number(cart.total_price) || 0;
    var unlocked = total >= threshold;
    var remaining = Math.max(0, threshold - total);
    var progress = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 100;
    var textEl = el.querySelector('[data-vibee-cart-drawer-shipping-text]');
    var fillEl = el.querySelector('[data-vibee-cart-drawer-shipping-fill]');
    el.classList.toggle('is-shipping-unlocked', unlocked);
    if (textEl) {
      textEl.textContent = unlocked
        ? label('freeShippingUnlocked', 'Ücretsiz kargo kazandınız ✓')
        : interpolate(label('freeShippingRemaining', 'Ücretsiz kargoya {{ amount }} TL'), {
            amount: formatMoney(remaining).replace(/\s*TL\s*$/i, '').trim(),
          });
    }
    if (fillEl) fillEl.style.width = progress + '%';
  }

  function renderLineItem(item) {
    var title = item.product_title || item.title || '';
    var variant =
      item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var img = item.image || item.featured_image && item.featured_image.url || '';
    var saleLine = Number(item.final_line_price) || Number(item.line_price) || 0;
    var qty = Number(item.quantity) || 1;
    var info = priceInfoCache[item.variant_id] || {};
    var unitCompare = Number(info.compareAt) || 0;
    var unitSale = Number(item.price) || 0;
    var onSale = unitCompare > unitSale && unitCompare > 0;
    var offPct = onSale ? Math.round(((unitCompare - unitSale) / unitCompare) * 100) : 0;
    var priceHtml = onSale
      ? '<p class="vibee-cart-drawer__line-price vibee-cart-drawer__line-price--sale">' +
        '<s class="vibee-cart-drawer__line-was">' + escapeHtml(formatMoney(unitCompare * qty)) + '</s>' +
        '<span class="vibee-cart-drawer__line-now">' + escapeHtml(formatMoney(saleLine)) + '</span>' +
        (offPct > 0 ? '<span class="vibee-cart-drawer__line-off">%' + offPct + '</span>' : '') +
        '</p>'
      : '<p class="vibee-cart-drawer__line-price">' + escapeHtml(formatMoney(saleLine)) + '</p>';
    return (
      '<li class="vibee-cart-drawer__line" data-vibee-cart-drawer-line data-key="' +
      escapeHtml(item.key) +
      '">' +
      '<a class="vibee-cart-drawer__line-media" href="' +
      escapeHtml(item.url || '#') +
      '">' +
      (img
        ? '<img src="' + escapeHtml(img) + '" alt="" width="64" height="64" loading="lazy">'
        : '') +
      '</a>' +
      '<div class="vibee-cart-drawer__line-body">' +
      '<a class="vibee-cart-drawer__line-title" href="' +
      escapeHtml(item.url || '#') +
      '">' +
      escapeHtml(title) +
      '</a>' +
      ratingMiniHtml(item.handle) +
      (variant ? '<p class="vibee-cart-drawer__line-variant">' + escapeHtml(variant) + '</p>' : '') +
      priceHtml +
      '<div class="vibee-cart-drawer__line-actions">' +
      '<div class="vibee-cart-drawer__qty">' +
      '<button type="button" class="vibee-cart-drawer__qty-btn" data-vibee-cart-drawer-qty-minus aria-label="' +
      escapeHtml(label('qtyMinus', 'Azalt')) +
      '">−</button>' +
      '<span class="vibee-cart-drawer__qty-value">' +
      String(item.quantity) +
      '</span>' +
      '<button type="button" class="vibee-cart-drawer__qty-btn" data-vibee-cart-drawer-qty-plus aria-label="' +
      escapeHtml(label('qtyPlus', 'Artır')) +
      '">+</button>' +
      '</div>' +
      '<button type="button" class="vibee-cart-drawer__remove" data-vibee-cart-drawer-remove>' +
      escapeHtml(label('remove', 'Kaldır')) +
      '</button>' +
      '</div></div></li>'
    );
  }

  function renderLines(cart) {
    var el = getDrawer();
    if (!el) return;
    var linesEl = el.querySelector('[data-vibee-cart-drawer-lines]');
    if (!linesEl) return;
    var html = '';
    var items = cart.items || [];
    var i = 0;
    while (i < items.length) {
      var item = items[i];
      var bundleId = itemProp(item, 'bundle_id');
      if (bundleId) {
        var group = [item];
        var j = i + 1;
        while (j < items.length && itemProp(items[j], 'bundle_id') === bundleId) {
          group.push(items[j]);
          j += 1;
        }
        html +=
          '<li class="vibee-cart-drawer__bundle-group"><p class="vibee-cart-drawer__bundle-badge">' +
          escapeHtml(label('bundleBadge', '%15 SET İNDİRİMİ')) +
          '</p><ul class="vibee-cart-drawer__lines" role="list">';
        group.forEach(function (groupItem) {
          html += renderLineItem(groupItem);
        });
        html += '</ul></li>';
        i = j;
      } else {
        html += renderLineItem(item);
        i += 1;
      }
    }
    linesEl.innerHTML = html;
  }

  function renderSmile(cart) {
    var el = getDrawer();
    if (!el) return;
    var wrap = el.querySelector('[data-vibee-cart-drawer-smile]');
    var line = el.querySelector('[data-vibee-cart-drawer-smile-line]');
    if (!wrap || !line) return;
    if (!cart.item_count) {
      wrap.hidden = true;
      return;
    }
    var pts = calculateClubPoints(cart.total_price);
    line.textContent = interpolate(
      label('smileLine', 'Bu siparişle ~{{ points }} puan kazan (≈ ₺{{ value }})'),
      { points: formatTrInteger(pts.points), value: formatTrInteger(pts.valueTl) },
    );
    wrap.hidden = false;
  }

  function pickCrossSellHandles(cart) {
    var TARGET = 2;
    var items = cart.items || [];
    var inCartHandle = {};
    var inCartVariant = {};
    var cartHasPet = false;
    items.forEach(function (item) {
      if (item.handle) inCartHandle[item.handle] = true;
      if (item.variant_id != null) inCartVariant[String(item.variant_id)] = true;
      if ((item.vendor || '') === 'BioFeline') cartHasPet = true;
    });

    var picks = [];
    var rules = crossSellData.rules || {};
    var pairings = crossSellData.pairings || {};
    var vendorFallback = crossSellData.vendorFallback || {};
    var allProducts = crossSellData.products || [];

    function eligible(handle) {
      if (picks.indexOf(handle) !== -1) return false;
      if (inCartHandle[handle]) return false;
      var product = productByHandle[handle];
      if (!product || !isAllowedCrossSellProduct(product)) return false;
      if (product.variantId != null && inCartVariant[String(product.variantId)]) return false;
      return true;
    }
    function tryPush(handle) {
      if (picks.length >= TARGET) return;
      if (eligible(handle)) picks.push(handle);
    }

    // Tier 1 — elle özel eşleşme (rules[handle])
    items.forEach(function (item) {
      if (picks.length >= TARGET) return;
      if (item.handle && rules[item.handle]) rules[item.handle].forEach(tryPush);
    });

    // Tier 2 — kategori-eşi (product_type), FARKLI marka tercihli
    if (picks.length < TARGET) {
      items.forEach(function (item) {
        if (picks.length >= TARGET) return;
        var targets = pairings[item.product_type || ''] || [];
        if (!targets.length) return;
        var vendor = item.vendor || '';
        [false, true].forEach(function (allowSameVendor) {
          if (picks.length >= TARGET) return;
          allProducts.forEach(function (p) {
            if (picks.length >= TARGET) return;
            if (!p || !p.handle) return;
            if (targets.indexOf(p.productType) === -1) return;
            if (!allowSameVendor && p.vendor === vendor) return;
            tryPush(p.handle);
          });
        });
      });
    }

    // Tier 3 — aynı marka yedeği (izolasyon: BioFeline vb.)
    if (picks.length < TARGET) {
      items.forEach(function (item) {
        if (picks.length >= TARGET) return;
        (vendorFallback[item.vendor || ''] || []).forEach(tryPush);
      });
    }

    // Tier 4 — CATCH-ALL: liste 2'ye tamamlanana kadar geniş katalogdan doldur.
    // Pet izolasyonu: insan sepetine BioFeline önerilmez (cart'ta pet yoksa atla).
    if (picks.length < TARGET) {
      allProducts.forEach(function (p) {
        if (picks.length >= TARGET) return;
        if (!p || !p.handle) return;
        if (!cartHasPet && p.vendor === 'BioFeline') return;
        tryPush(p.handle);
      });
    }

    return picks.slice(0, TARGET).map(function (h) {
      return productByHandle[h];
    });
  }

  function renderCrossSell(cart) {
    var el = getDrawer();
    if (!el) return;
    var section = el.querySelector('[data-vibee-cart-drawer-cross-sell]');
    var list = el.querySelector('[data-vibee-cart-drawer-cross-sell-list]');
    if (!section || !list) return;
    var suggestions = pickCrossSellHandles(cart);
    if (!suggestions.length) {
      section.hidden = true;
      list.innerHTML = '';
      return;
    }
    list.innerHTML = suggestions
      .map(function (product) {
        return (
          '<li class="vibee-cart-drawer__cross-sell-item">' +
          (product.image
            ? '<img class="vibee-cart-drawer__cross-sell-thumb" src="' +
              escapeHtml(product.image) +
              '" alt="" width="48" height="48" loading="lazy">'
            : '<span class="vibee-cart-drawer__cross-sell-thumb" aria-hidden="true"></span>') +
          '<div class="vibee-cart-drawer__cross-sell-copy">' +
          '<a class="vibee-cart-drawer__cross-sell-name" href="' +
          escapeHtml(product.url || '#') +
          '">' +
          escapeHtml(product.title) +
          '</a>' +
          ratingMiniHtml(product.handle) +
          '<p class="vibee-cart-drawer__cross-sell-price">' +
          escapeHtml(formatMoney(product.price)) +
          '</p></div>' +
          '<button type="button" class="vibee-cart-drawer__cross-sell-add" data-vibee-cart-drawer-cross-add data-variant-id="' +
          String(product.variantId) +
          '">' +
          escapeHtml(label('crossSellAdd', '+ Ekle')) +
          '</button></li>'
        );
      })
      .join('');
    section.hidden = false;
  }

  function renderSummary(cart) {
    var el = getDrawer();
    if (!el) return;
    var summary = el.querySelector('[data-vibee-cart-drawer-summary]');
    if (!summary) return;
    var hasBundle = (cart.items || []).some(function (item) {
      return !!itemProp(item, 'bundle_id');
    });
    var codeDiscounts = cart.cart_level_discount_applications || [];

    var regularTotal = 0;
    (cart.items || []).forEach(function (it) {
      var info = priceInfoCache[it.variant_id] || {};
      var qty = Number(it.quantity) || 1;
      var unitCompare = Number(info.compareAt) || 0;
      var unitSale = Number(it.price) || 0;
      regularTotal += (unitCompare > unitSale ? unitCompare : unitSale) * qty;
    });
    var finalTotal = Number(cart.total_price) || 0;
    var savings = Math.max(0, regularTotal - finalTotal);

    var html = '';
    if (savings > 0) {
      html +=
        '<div class="vibee-cart-drawer__summary-row vibee-cart-drawer__summary-regular"><span>' +
        escapeHtml(label('regularTotal', 'Normal fiyat')) +
        '</span><s>' + escapeHtml(formatMoney(regularTotal)) + '</s></div>';
    }
    html +=
      '<div class="vibee-cart-drawer__summary-row"><span>' +
      escapeHtml(label('subtotal', 'Ara toplam')) +
      '</span><strong>' + escapeHtml(formatMoney(finalTotal)) + '</strong></div>';

    codeDiscounts.forEach(function (d) {
      html +=
        '<div class="vibee-cart-drawer__summary-row vibee-cart-drawer__summary-discount vibee-cart-drawer__summary-code">' +
        '<span class="vibee-cart-drawer__code-chip"><span class="vibee-cart-drawer__code-tag" aria-hidden="true">🏷</span>' +
        escapeHtml(d.title || '') + '</span><span>−' + escapeHtml(formatMoney(d.total_allocated_amount)) + '</span></div>';
    });

    if (savings > 0) {
      html +=
        '<div class="vibee-cart-drawer__summary-row vibee-cart-drawer__summary-savings"><span>' +
        escapeHtml(label('savings', 'Kazancın')) +
        '</span><strong>−' + escapeHtml(formatMoney(savings)) + '</strong></div>';
    }

    html +=
      '<p class="vibee-cart-drawer__summary-note">' +
      escapeHtml(label('taxNote', 'Kargo ve vergiler ödemede hesaplanır.')) + '</p>';
    if (hasBundle) {
      html +=
        '<p class="vibee-cart-drawer__summary-note">' +
        escapeHtml(label('bundleCouponNote', 'Bundle indirimi kupon kodlarıyla birleştirilemez')) + '</p>';
    }
    summary.innerHTML = html;
  }

  function renderDrawerState(cart) {
    var el = getDrawer();
    if (!el) return;
    var empty = el.querySelector('[data-vibee-cart-drawer-empty]');
    var linesWrap = el.querySelector('[data-vibee-cart-drawer-lines-wrap]');
    var footer = el.querySelector('[data-vibee-cart-drawer-footer]');
    var countEl = el.querySelector('[data-vibee-cart-drawer-count]');
    var shipping = el.querySelector('[data-vibee-cart-drawer-shipping]');
    var hasItems = Number(cart.item_count) > 0;

    if (countEl) {
      if (hasItems) {
        countEl.textContent = String(cart.item_count) + ' ürün';
        countEl.hidden = false;
      } else {
        countEl.hidden = true;
      }
    }

    if (empty) empty.hidden = hasItems;
    if (linesWrap) linesWrap.hidden = !hasItems;
    if (footer) footer.hidden = !hasItems;
    if (shipping) shipping.hidden = !hasItems;

    if (hasItems) {
      ensurePriceInfo(cart).then(function () {
        renderLines(cart);
        renderSmile(cart);
        renderCrossSell(cart);
        renderSummary(cart);
      });
    }

    renderShippingBar(cart);
    updateHeaderCartCount(cart);
    dispatchCartEvents(cart);
  }

  function flashAdded() {
    var el = getDrawer();
    if (!el) return;
    var flash = el.querySelector('[data-vibee-cart-drawer-flash]');
    if (!flash) return;
    flash.textContent = label('addedFlash', '✓ Sepete eklendi');
    flash.hidden = false;
    flash.classList.add('is-visible');
    if (flashTimer) clearTimeout(flashTimer);
    flashTimer = window.setTimeout(function () {
      flash.classList.remove('is-visible');
      flash.hidden = true;
    }, 1400);
  }

  function trapFocus(event) {
    var el = getDrawer();
    if (!el || !isOpen || event.key !== 'Tab') return;
    var focusable = el.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openDrawer(cart, options) {
    var el = getDrawer();
    if (!el) return;
    options = options || {};
    lastFocusEl = document.activeElement;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vibee-cart-drawer-open');
    renderDrawerState(cart);
    if (typeof window.vibeeSyncStickyAtcHeight === 'function') {
      window.vibeeSyncStickyAtcHeight();
    }
    window.requestAnimationFrame(function () {
      el.classList.add('is-open');
    });
    isOpen = true;
    var closeBtn = el.querySelector('.vibee-cart-drawer__close');
    if (closeBtn) closeBtn.focus();
    if (options.highlightAdd) flashAdded();
  }

  function closeDrawer() {
    var el = getDrawer();
    if (!el || !isOpen) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vibee-cart-drawer-open');
    isOpen = false;
    if (typeof window.vibeeSyncStickyAtcHeight === 'function') {
      window.vibeeSyncStickyAtcHeight();
    }
    window.setTimeout(function () {
      if (!isOpen) el.hidden = true;
    }, 260);
    if (lastFocusEl && typeof lastFocusEl.focus === 'function') lastFocusEl.focus();
  }

  function refreshDrawer(cart) {
    if (!cart) return fetchCart().then(renderDrawerState);
    renderDrawerState(cart);
    return Promise.resolve(cart);
  }

  function openCartDrawer(cart, addResult) {
    if (!isOpen) openDrawer(cart, { highlightAdd: !!addResult });
    else {
      renderDrawerState(cart);
      flashAdded();
    }
  }

  function syncAfterAdd(cart, addResult) {
    openCartDrawer(cart, addResult);
  }

  function showError(message) {
    if (!errorEl) errorEl = document.querySelector('[data-vibee-cart-drawer-error]');
    if (!errorEl) return;
    errorEl.textContent = message || label('error', 'Sepete eklenemedi — tekrar dene');
    errorEl.hidden = false;
    errorEl.classList.add('is-visible');
    if (errorTimer) clearTimeout(errorTimer);
    errorTimer = window.setTimeout(function () {
      errorEl.hidden = true;
      errorEl.classList.remove('is-visible');
    }, 4200);
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('change_failed');
        return response.json();
      })
      .then(function (cart) {
        renderDrawerState(cart);
        return cart;
      });
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add_failed');
        return response.json();
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        renderDrawerState(cart);
        flashAdded();
        return cart;
      })
      .catch(function () {
        showError();
      });
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var closeTarget = event.target.closest('[data-vibee-cart-drawer-close]');
      if (closeTarget && isOpen) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var cartLink = event.target.closest('.vibee-icon-link--cart');
      if (cartLink && !event.metaKey && !event.ctrlKey && event.button === 0) {
        event.preventDefault();
        fetchCart()
          .then(function (cart) {
            openCartDrawer(cart);
          })
          .catch(function () {
            window.location.href = config.cartUrl || '/cart';
          });
        return;
      }

      if (!isOpen) return;

      var minus = event.target.closest('[data-vibee-cart-drawer-qty-minus]');
      if (minus) {
        event.preventDefault();
        var line = minus.closest('[data-vibee-cart-drawer-line]');
        var key = line && line.getAttribute('data-key');
        var qtyEl = line && line.querySelector('.vibee-cart-drawer__qty-value');
        var qty = qtyEl ? Number(qtyEl.textContent) : 1;
        if (key) changeLine(key, Math.max(0, qty - 1));
        return;
      }

      var plus = event.target.closest('[data-vibee-cart-drawer-qty-plus]');
      if (plus) {
        event.preventDefault();
        var linePlus = plus.closest('[data-vibee-cart-drawer-line]');
        var keyPlus = linePlus && linePlus.getAttribute('data-key');
        var qtyElPlus = linePlus && linePlus.querySelector('.vibee-cart-drawer__qty-value');
        var qtyPlus = qtyElPlus ? Number(qtyElPlus.textContent) : 1;
        if (keyPlus) changeLine(keyPlus, qtyPlus + 1);
        return;
      }

      var removeBtn = event.target.closest('[data-vibee-cart-drawer-remove]');
      if (removeBtn) {
        event.preventDefault();
        var lineRemove = removeBtn.closest('[data-vibee-cart-drawer-line]');
        var keyRemove = lineRemove && lineRemove.getAttribute('data-key');
        if (keyRemove) changeLine(keyRemove, 0);
        return;
      }

      var crossAdd = event.target.closest('[data-vibee-cart-drawer-cross-add]');
      if (crossAdd) {
        event.preventDefault();
        var variantId = crossAdd.getAttribute('data-variant-id');
        if (variantId) addVariant(variantId);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) {
        event.preventDefault();
        closeDrawer();
      }
      trapFocus(event);
    });
  }

  window.vibeeCartDrawer = {
    openCartDrawer: openCartDrawer,
    syncAfterAdd: syncAfterAdd,
    showError: showError,
    refresh: refreshDrawer,
    close: closeDrawer,
    updateHeaderCartCount: updateHeaderCartCount,
    dispatchCartEvents: dispatchCartEvents,
  };

  loadConfig();
  loadCrossSell();
  bindEvents();

  window.addEventListener('pagehide', function () {
    try {
      if (isOpen) closeDrawer();
    } catch (e) {}
  });
  } catch (e) {
    console.error('vibee-cart-drawer: fatal init error', e);
  }
})();
